"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NumberFormatter = exports.formatNumberLessThan = exports.formatNumber = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var formatNumber = function formatNumber(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal'
  }).format(value);
};

exports.formatNumber = formatNumber;

var formatNumberLessThan = function formatNumberLessThan(value, mask) {
  if (value > 0 && value < mask) {
    return "Fewer than ".concat(mask);
  }

  return formatNumber(value);
};

exports.formatNumberLessThan = formatNumberLessThan;

var NumberFormatter = function NumberFormatter(_ref) {
  var mask = _ref.mask,
      children = _ref.children; // plain number

  if (typeof children === 'number') {
    if (mask) {
      return /*#__PURE__*/_react.default.createElement("span", null, formatNumberLessThan(children, mask));
    }

    return /*#__PURE__*/_react.default.createElement("span", null, formatNumber(children));
  } // cust_a object


  if (_typeof(children) === 'object') {
    var maskObj = children;

    if (typeof maskObj.mask === 'number') {
      // value probably masked
      if (maskObj.val < maskObj.mask) {
        return /*#__PURE__*/_react.default.createElement("span", null, "Fewer than $", maskObj.mask);
      }
    } else if (maskObj.masked) {
      return /*#__PURE__*/_react.default.createElement("span", null, " Fewer than ", maskObj.val + 1, " ");
    }

    var formattedValue = formatNumber(maskObj.val);
    return /*#__PURE__*/_react.default.createElement("span", null, formattedValue);
  }

  return children;
};

exports.NumberFormatter = NumberFormatter;
NumberFormatter.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.number, _propTypes.default.element]).isRequired,
  mask: _propTypes.default.number
};
var _default = NumberFormatter;
exports.default = _default;